import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_5u453aubma: FaireCollectionEntity = {
  token: "pbc_5u453aubma",
  type: "collection",
  name: "tropical",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ee43a1b034917426457ce7ab4643ff3b08ffd210c84428ec5bfd2f00808eceb8.jpeg",
  itemCount: 17,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:22.346Z",
    importedBy: "entity-db-import-collections",
  },
};
